module.exports = __webpack_public_path__ + "img/SOKAL-SRS-121021-Eclipse-Lifestyle.8c0bcdd3.jpeg";